<div class="card-body d-flex flex-column gap-24" [class.changes-hidden]="!companyDetailsViewModel().isPendingChangesVisible">
  <div class="officeholder-contact-container">
    <div class="form-group">
      <div class="title">Company name</div>

      @if (companyDetailsViewModel().lodgedCompany.name !== companyDetailsViewModel().companyWithPendingChanges.name) {
        <div class="property previous">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.name | defaultValue }}</div>
        </div>

        <div class="property current">
          <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.name | defaultValue }}</div>
        </div>
      } @else {
        <div class="property">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.name | defaultValue }}</div>
        </div>
      }
    </div>

    <div class="form-group">
      <div class="title">Company type</div>

      @if (companyDetailsViewModel().companyDifference?.companyType !== undefined || companyDetailsViewModel().companyDifference?.companySubtype !== undefined) {
        <div class="property previous" appCopy>
          <div class="property previous d-inline">{{ companyDetailsViewModel().lodgedCompany.companyType | companyType }}</div>
          <span> - </span>
          <div class="property previous d-inline">{{ companyDetailsViewModel().lodgedCompany.companySubtype | companySubtype }}</div>
        </div>

        <div class="property current" appCopy>
          <div class="property current d-inline">{{ companyDetailsViewModel().companyWithPendingChanges.companyType | companyType }}</div>
          <span> - </span>
          <div class="property current d-inline">{{ companyDetailsViewModel().companyWithPendingChanges.companySubtype | companySubtype }}</div>
        </div>
      } @else {
        <div class="property" appCopy>
          <div class="property d-inline">{{ companyDetailsViewModel().lodgedCompany.companyType | companyType }}</div>
          <span> - </span>
          <div class="property d-inline">{{ companyDetailsViewModel().lodgedCompany.companySubtype | companySubtype }}</div>
        </div>
      }
    </div>
  </div>

  <div class="officeholder-info-container">
    <div class="form-group">
      <div class="title">ACN</div>

      @if (companyDetailsViewModel().lodgedCompany.acn !== companyDetailsViewModel().companyWithPendingChanges.acn) {
        <div class="property previous">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.acn | acn }}</div>
        </div>

        <div class="property current">
          <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.acn | acn }}</div>
        </div>
      } @else {
        <div class="property">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.acn | acn }}</div>
        </div>
      }
    </div>

    <div class="form-group">
      <div class="title">Company status</div>

      @if (companyDetailsViewModel().lodgedCompany.status !== companyDetailsViewModel().companyWithPendingChanges.status) {
        <div class="property previous text-capitalize">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.status | companyStatus }}</div>
        </div>

        <div class="property current text-capitalize">
          <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.status | companyStatus }}</div>
        </div>
      } @else {
        <div class="property text-capitalize">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.status | companyStatus }}</div>
        </div>
      }
    </div>

    <div class="form-group">
      <div class="title">Registration date</div>

      @if ((companyDetailsViewModel().lodgedCompany.dateOfEstablishment | dateFormat) !== (companyDetailsViewModel().companyWithPendingChanges.dateOfEstablishment | dateFormat)) {
        <div class="property previous">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.dateOfEstablishment | dateFormat }}</div>
        </div>

        <div class="property current">
          <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.dateOfEstablishment | dateFormat }}</div>
        </div>
      } @else {
        <div class="property">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.dateOfEstablishment | dateFormat }}</div>
        </div>
      }
    </div>

    <div class="form-group">
      <div class="title">New annual review</div>

      @if ((companyDetailsViewModel().lodgedCompany.nextAnnualReviewDate | dateFormat) !== (companyDetailsViewModel().companyWithPendingChanges.nextAnnualReviewDate | dateFormat)) {
        <div class="property previous">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.nextAnnualReviewDate | dateFormat }}</div>
        </div>

        <div class="property current">
          <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.nextAnnualReviewDate | dateFormat }}</div>
        </div>
      } @else {
        <div class="property">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.nextAnnualReviewDate | dateFormat }}</div>
        </div>
      }
    </div>
  </div>

  <div class="officeholder-info-container">
    <div class="form-group">
      <div class="title">Ultimate holding company</div>

      @if (companyDetailsViewModel().lodgedCompany.ultimateHoldingCompany?.name !== companyDetailsViewModel().companyWithPendingChanges.ultimateHoldingCompany?.name) {
        <div class="property previous">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.ultimateHoldingCompany?.name | defaultValue }}</div>
        </div>

        <div class="property current">
          <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.ultimateHoldingCompany?.name | defaultValue }}</div>
        </div>
      } @else {
        <div class="property">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.ultimateHoldingCompany?.name | defaultValue }}</div>
        </div>
      }
    </div>

    <div></div>

    <div class="form-group">
      <div class="title">Corporate key</div>

      @if (companyDetailsViewModel().lodgedCompany.corporateKey !== companyDetailsViewModel().companyWithPendingChanges.corporateKey) {
        <div class="property previous">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.corporateKey | defaultValue }}</div>
        </div>

        <div class="property current">
          <div appCopy> {{ companyDetailsViewModel().companyWithPendingChanges.corporateKey | defaultValue }}</div>
        </div>
      } @else {
        <div class="property">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.corporateKey | defaultValue }}</div>
        </div>
      }
    </div>

    <div class="form-group">
      <div class="title">Jurisdiction</div>

      @if (companyDetailsViewModel().lodgedCompany.jurisdiction !== companyDetailsViewModel().companyWithPendingChanges.jurisdiction) {
        <div class="property previous">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.jurisdiction | jurisdiction }}</div>
        </div>

        <div class="property current">
          <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.jurisdiction | jurisdiction }}</div>
        </div>
      } @else {
        <div class="property">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.jurisdiction | jurisdiction }}</div>
        </div>
      }
    </div>
  </div>

  <app-divider/>

  <div class="officeholder-contact-container">
    <div class="form-group">
      <div class="title">Registered address</div>

      @if (companyDetailsViewModel().lodgedCompany.registeredAddress.normalizedFullAddress !== companyDetailsViewModel().companyWithPendingChanges.registeredAddress.normalizedFullAddress) {
        <div class="property previous">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.registeredAddress.normalizedFullAddress | defaultValue }}</div>
        </div>

        <div class="property current">
          <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.registeredAddress.normalizedFullAddress | defaultValue }}</div>
        </div>
      } @else {
        <div class="property">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.registeredAddress.normalizedFullAddress | defaultValue }}</div>
        </div>
      }
    </div>

    <div class="form-group">
      <div class="title">Principal address</div>

      @if (companyDetailsViewModel().lodgedCompany.principalAddress.normalizedFullAddress !== companyDetailsViewModel().companyWithPendingChanges.principalAddress.normalizedFullAddress) {
        <div class="property previous">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.principalAddress.normalizedFullAddress | defaultValue }}</div>
        </div>

        <div class="property current">
          <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.principalAddress.normalizedFullAddress | defaultValue }}</div>
        </div>
      } @else {
        <div class="property">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.principalAddress.normalizedFullAddress | defaultValue }}</div>
        </div>
      }
    </div>
  </div>

  <app-divider/>

  <div class="officeholder-contact-container">
    <div class="form-group">
      <div class="title">Partner</div>

      @if (companyDetailsViewModel().lodgedCompany.partnerManager?.fullName !== companyDetailsViewModel().companyWithPendingChanges.partnerManager?.fullName) {
        <div class="property previous">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.partnerManager?.fullName | defaultValue }}</div>
        </div>

        <div class="property current">
          <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.partnerManager?.fullName | defaultValue }}</div>
        </div>
      } @else {
        <div class="property">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.partnerManager?.fullName | defaultValue }}</div>
        </div>
      }
    </div>

    <div class="form-group">
      <div class="title">Account Manager</div>

      @if (companyDetailsViewModel().lodgedCompany.accountManager?.fullName !== companyDetailsViewModel().companyWithPendingChanges.accountManager?.fullName) {
        <div class="property previous">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.accountManager?.fullName | defaultValue }}</div>
        </div>

        <div class="property current">
          <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.accountManager?.fullName | defaultValue }}</div>
        </div>
      } @else {
        <div class="property">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.accountManager?.fullName | defaultValue }}</div>
        </div>
      }
    </div>
  </div>

  <app-divider/>

  <div class="officeholder-contact-container">
    <div class="form-group">
      <div class="title">Reference Number</div>

      @if (companyDetailsViewModel().lodgedCompany.referenceNumber !== companyDetailsViewModel().companyWithPendingChanges.referenceNumber) {
        <div class="property previous">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.referenceNumber | defaultValue }}</div>
        </div>

        <div class="property current">
          <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.referenceNumber | defaultValue }}</div>
        </div>
      } @else {
        <div class="property">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.referenceNumber | defaultValue }}</div>
        </div>
      }
    </div>

    <div class="form-group">
      <div class="title">Family group</div>

      @if (companyDetailsViewModel().lodgedCompany.familyGroup !== companyDetailsViewModel().companyWithPendingChanges.familyGroup) {
        <div class="property previous">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.familyGroup | defaultValue }}</div>
        </div>

        <div class="property current">
          <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.familyGroup | defaultValue }}</div>
        </div>
      } @else {
        <div class="property">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.familyGroup | defaultValue }}</div>
        </div>
      }
    </div>
  </div>

  <app-divider/>

  <div class="officeholder-contact-container">
    <div class="form-group">
      <div class="title">Signing Contact</div>

      @if (companyDetailsViewModel().companyDifference?.signingContact?.fullName) {
        <div class="property previous">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.signingContact?.fullName | defaultValue }}</div>
        </div>

        <div class="property current">
          <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.signingContact?.fullName | defaultValue }}</div>
        </div>
      } @else {
        <div class="property">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.signingContact?.fullName | defaultValue }}</div>
        </div>
      }

      @if (companyDetailsViewModel().lodgedCompany.signingContact?.email !== companyDetailsViewModel().companyWithPendingChanges.signingContact?.email) {
        <div class="contact form-group mb-1">
          <span class="contact-icon mr-1">&#64;</span>
          <div class="property previous">
            <div appCopy>{{ companyDetailsViewModel().lodgedCompany.signingContact?.email | defaultValue }}</div>
          </div>
        </div>

        <div class="contact form-group mb-1">
          <span class="contact-icon mr-1">&#64;</span>
          <div class="property current">
            <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.signingContact?.email | defaultValue }}</div>
          </div>
        </div>
      } @else {
        <div class="contact form-group mb-1">
          <span class="contact-icon mr-1">&#64;</span>
          <div class="property">
            <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.signingContact?.email | defaultValue }}</div>
          </div>
        </div>
      }

      @if (companyDetailsViewModel().lodgedCompany.signingContact?.phone !== companyDetailsViewModel().companyWithPendingChanges.signingContact?.phone) {
        <div class="contact form-group align-items-center">
          <i class="icon ic-phone-16 mr-1"></i>
          <div class="property previous">
            <div appCopy>{{ companyDetailsViewModel().lodgedCompany.signingContact?.phone | phone | defaultValue }}</div>
          </div>
        </div>

        <div class="contact form-group align-items-center">
          <i class="icon ic-phone-16 mr-1"></i>
          <div class="property current">
            <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.signingContact?.phone | phone | defaultValue }}</div>
          </div>
        </div>
      } @else {
        <div class="contact form-group align-items-center">
          <i class="icon ic-phone-16 mr-1"></i>
          <div class="property">
            <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.signingContact?.phone | phone | defaultValue }}</div>
          </div>
        </div>
      }
    </div>

    <div class="form-group">
      <div class="title">Billing Contact</div>

      @if (companyDetailsViewModel().companyDifference?.billingContact?.fullName) {
        <div class="property previous">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.billingContact?.fullName | defaultValue }}</div>
        </div>

        <div class="property current">
          <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.billingContact?.fullName | defaultValue }}</div>
        </div>
      } @else {
        <div class="property">
          <div appCopy>{{ companyDetailsViewModel().lodgedCompany.billingContact?.fullName | defaultValue }}</div>
        </div>
      }

      @if (companyDetailsViewModel().lodgedCompany.billingContact?.email !== companyDetailsViewModel().companyWithPendingChanges.billingContact?.email) {
        <div class="contact form-group mb-1">
          <span class="contact-icon mr-1">&#64;</span>
          <div class="property previous">
            <div appCopy>{{ companyDetailsViewModel().lodgedCompany.billingContact?.email | defaultValue }}</div>
          </div>
        </div>

        <div class="contact form-group mb-1">
          <span class="contact-icon mr-1">&#64;</span>
          <div class="property current">
            <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.billingContact?.email | defaultValue }}</div>
          </div>
        </div>
      } @else {
        <div class="contact form-group mb-1">
          <span class="contact-icon mr-1">&#64;</span>
          <div class="property">
            <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.billingContact?.email | defaultValue }}</div>
          </div>
        </div>
      }

      @if (companyDetailsViewModel().lodgedCompany.billingContact?.phone !== companyDetailsViewModel().companyWithPendingChanges.billingContact?.phone) {
        <div class="contact form-group align-items-center">
          <i class="icon ic-phone-16 mr-1"></i>
          <div class="property previous">
            <div appCopy>{{ companyDetailsViewModel().lodgedCompany.billingContact?.phone | phone | defaultValue }}</div>
          </div>
        </div>

        <div class="contact form-group align-items-center">
          <i class="icon ic-phone-16 mr-1"></i>
          <div class="property current">
            <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.billingContact?.phone | phone | defaultValue }}</div>
          </div>
        </div>
      } @else {
        <div class="contact form-group align-items-center">
          <i class="icon ic-phone-16 mr-1"></i>
          <div class="property">
            <div appCopy>{{ companyDetailsViewModel().companyWithPendingChanges.billingContact?.phone | phone | defaultValue }}</div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
